import { Component, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pkp-toggle',
    template: `
        <div
            class="slider"
            [ngClass]="{ on: on, disabled: disabled }"
            (click)="!disabled && (on = !on)"
        >
            <small *ngIf="on">Yes</small>
            <div class="circle"></div>
            <small *ngIf="!on">No</small>
        </div>
    `,
    styles: [
        `
            .slider {
                cursor: pointer;
                position: relative;
            }
        `,
        `
            .slider > small {
                position: absolute;
                font-size: 12px;
                padding-top: 3px;
                padding-bottom: 3px;
            }
        `,
        `
            .slider.on > small {
                color: white;
                left: 0;
                padding-left: 6px;
            }
        `,
        `
            .slider:not(.on) > small {
                color: #999;
                right: 0;
                padding-right: 8px;
            }
        `,
        `
            .slider {
                display: inline-block;
                border-radius: 25px;
                width: 54px;
                height: 25px;
                transition:
                    background-color 300ms,
                    border-color 300ms;
            }
        `,
        `
            .circle {
                height: 23px;
                width: 23px;
                display: inline-block;
                border-radius: 50%;
                padding: 0;
                margin: 0;
                background-color: white;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
                transition: transform 300ms;
            }
        `,
        `
            .slider.on {
                background-color: #009d60;
                border: 1px solid #009d60;
            }
        `,
        `
            .slider:not(.on) {
                background-color: #efefef;
                border: 1px solid #dfdfdf;
            }
        `,
        `
            .slider.on .circle {
                transform: translateX(29px);
            }
        `,
        `
            .slider:not(.on) .circle {
                transform: translateX(0);
            }
        `,
        `
            .slider.disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        `
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true
        }
    ]
})
export class ToggleComponent implements ControlValueAccessor, OnChanges {
    private propagateChange: (_: any) => void = () => {};
    private _on: boolean;

    disabled: boolean;

    set on(val: any) {
        this._on = !!val;
        this.propagateChange(!!val);
    }

    get on() {
        return this._on;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {}

    writeValue(obj: any): void {
        obj != null && (this._on = !!obj);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.propagateChange(this.on);
    }
}
